<template>
  <div style="min-width: 1300px;">
  	
  	<layout>
  	
      <div slot="body" scope="props" class="container-padding" style="padding-bottom: 20px;">
	  		<!--按钮列表-->
		    <btnList style="margin-top: 20px;"></btnList>
		    <!--数据列表-->
		    <dataCenter style="margin-top: 20px;"></dataCenter>
		    <!--代理机构列表-->
		    <agencylist style="margin-top: 20px;"></agencylist>
	  	</div>
  	</layout>
  	
  	
   
  </div>
</template>

<script>
import layout from '@/view/layout/index.vue'
	
//引入按钮列表
import btnList from '@/view/index/btnList/index.vue'
//引入数据列表
import dataCenter from '@/view/index/dataCenter/index.vue'
//引入代理机构列表
import agencylist from '@/view/index/data/agencylist.vue'
	
export default {
  name: 'index',
	components: {
		btnList:btnList,
		dataCenter:dataCenter,
		agencylist:agencylist,
		layout:layout
	}
}
</script>

<style scoped>
	.container-padding{
		padding: 0 8%;
	}
	
</style>



// WEBPACK FOOTER //
// src/view/index/index.vue